<template>
  <svg
    id="Composant_117_1"
    data-name="Composant 117 – 1"
    width="1231.999"
    height="379.91"
    viewBox="0 0 1231.999 379.91"
  >
    <g
      id="Changez_vos_habitudes"
      data-name="Changez vos habitudes"
      transform="translate(-376 -148)"
    >
      <g
        id="Composant_106_1"
        data-name="Composant 106 – 1"
        transform="translate(376 319.471)"
      >
        <g
          id="TP"
          transform="translate(685.623 7.378)"
        >
          <ellipse
            id="Ellipse_123"
            data-name="Ellipse 123"
            class="cls-1"
            cx="97.188"
            cy="14.268"
            rx="97.188"
            ry="14.268"
            transform="translate(0 172.525)"
          />
          <g
            id="Groupe_664"
            data-name="Groupe 664"
            transform="translate(6.66 0)"
          >
            <g
              id="bus"
              transform="translate(0)"
            >
              <g
                id="Groupe_661"
                data-name="Groupe 661"
                transform="translate(28.795 163.421)"
              >
                <path
                  id="Tracé_2417"
                  data-name="Tracé 2417"
                  class="cls-2"
                  d="M79.019,445.642V458.6a5.692,5.692,0,0,0,5.689,5.689h18.144a5.692,5.692,0,0,0,5.689-5.689V445.642Z"
                  transform="translate(-79.019 -445.642)"
                />
                <path
                  id="Tracé_2418"
                  data-name="Tracé 2418"
                  class="cls-2"
                  d="M336.958,445.642V458.6a5.692,5.692,0,0,0,5.689,5.689h18.144a5.692,5.692,0,0,0,5.689-5.689V445.642Z"
                  transform="translate(-242.37 -445.642)"
                />
              </g>
              <path
                id="Tracé_2419"
                data-name="Tracé 2419"
                class="cls-3"
                d="M460.218,106.587a2.95,2.95,0,0,1-2.953-2.953,3.789,3.789,0,0,0-3.784-3.784h-3.243a2.953,2.953,0,0,1,0-5.905h3.243a9.7,9.7,0,0,1,9.689,9.684A2.955,2.955,0,0,1,460.218,106.587Z"
                transform="translate(-283.444 -59.495)"
              />
              <rect
                id="Rectangle_1218"
                data-name="Rectangle 1218"
                class="cls-2"
                width="11.846"
                height="31.987"
                transform="translate(169.856 43.616)"
              />
              <path
                id="Tracé_2420"
                data-name="Tracé 2420"
                class="cls-3"
                d="M8.834,106.587a2.95,2.95,0,0,0,2.953-2.953A3.786,3.786,0,0,1,15.57,99.85h3.243a2.953,2.953,0,1,0,0-5.905H15.57a9.7,9.7,0,0,0-9.689,9.684A2.955,2.955,0,0,0,8.834,106.587Z"
                transform="translate(-3.906 -59.495)"
              />
              <rect
                id="Rectangle_1219"
                data-name="Rectangle 1219"
                class="cls-2"
                width="11.846"
                height="31.987"
                transform="translate(0 43.616)"
              />
              <path
                id="Tracé_2421"
                data-name="Tracé 2421"
                class="cls-4"
                d="M181.556,0H52.153A11.379,11.379,0,0,0,40.774,11.379V113.723H192.935V11.379A11.376,11.376,0,0,0,181.556,0Z"
                transform="translate(-26.004)"
              />
              <path
                id="Tracé_2422"
                data-name="Tracé 2422"
                class="cls-5"
                d="M40.774,411.85v3.129a11.383,11.383,0,0,0,11.379,11.379h129.4a11.38,11.38,0,0,0,11.379-11.379V411.85Z"
                transform="translate(-26.004 -260.821)"
              />
              <rect
                id="Rectangle_1220"
                data-name="Rectangle 1220"
                class="cls-2"
                width="152.161"
                height="16.335"
                transform="translate(14.77 134.672)"
              />
              <rect
                id="Rectangle_1221"
                data-name="Rectangle 1221"
                class="cls-6"
                width="152.161"
                height="24.624"
                transform="translate(14.77 110.07)"
              />
              <rect
                id="Rectangle_1222"
                data-name="Rectangle 1222"
                class="cls-7"
                width="152.161"
                height="71.102"
                transform="translate(14.77 31.856)"
              />
              <rect
                id="Rectangle_1223"
                data-name="Rectangle 1223"
                class="cls-8"
                width="8.125"
                height="71.102"
                transform="translate(86.789 31.856)"
              />
              <rect
                id="Rectangle_1224"
                data-name="Rectangle 1224"
                class="cls-4"
                width="152.161"
                height="7.112"
                transform="translate(14.77 102.958)"
              />
              <ellipse
                id="Ellipse_171"
                data-name="Ellipse 171"
                class="cls-6"
                cx="4.449"
                cy="4.449"
                rx="4.449"
                ry="4.449"
                transform="translate(26.718 138.409)"
              />
              <g
                id="Groupe_662"
                data-name="Groupe 662"
                transform="translate(38.041 138.409)"
              >
                <ellipse
                  id="Ellipse_172"
                  data-name="Ellipse 172"
                  class="cls-9"
                  cx="4.449"
                  cy="4.449"
                  rx="4.449"
                  ry="4.449"
                />
                <ellipse
                  id="Ellipse_173"
                  data-name="Ellipse 173"
                  class="cls-9"
                  cx="4.449"
                  cy="4.449"
                  rx="4.449"
                  ry="4.449"
                  transform="translate(96.722)"
                />
              </g>
              <ellipse
                id="Ellipse_174"
                data-name="Ellipse 174"
                class="cls-6"
                cx="4.449"
                cy="4.449"
                rx="4.449"
                ry="4.449"
                transform="translate(146.073 138.409)"
              />
              <g
                id="Groupe_663"
                data-name="Groupe 663"
                transform="translate(23.987 116.197)"
              >
                <path
                  id="Tracé_2423"
                  data-name="Tracé 2423"
                  class="cls-4"
                  d="M381.729,316.866H370.821a6.182,6.182,0,1,0,0,12.363h10.907a6.182,6.182,0,1,0,0-12.363Z"
                  transform="translate(-255.09 -316.866)"
                />
                <path
                  id="Tracé_2424"
                  data-name="Tracé 2424"
                  class="cls-4"
                  d="M83,316.866H72.093a6.182,6.182,0,1,0,0,12.363H83a6.182,6.182,0,0,0,0-12.363Z"
                  transform="translate(-65.908 -316.866)"
                />
              </g>
              <path
                id="Tracé_2425"
                data-name="Tracé 2425"
                class="cls-2"
                d="M192.265,13.545H102.342a10.961,10.961,0,0,0,0,21.922h89.923a10.961,10.961,0,0,0,0-21.922Z"
                transform="translate(-58.055 -8.578)"
              />
              <path
                id="Tracé_2426"
                data-name="Tracé 2426"
                class="cls-10"
                d="M192.935,86.869H40.774v34.456a6.281,6.281,0,0,0,5.8,6.355,6.007,6.007,0,0,0,6.355-6.008V110.526a5.109,5.109,0,0,1,5.388-5.041h.136a5.15,5.15,0,0,1,5.388,5.041v12.318a6.283,6.283,0,0,0,5.661,6.424,6.106,6.106,0,0,0,6.39-5.917V106.9a6.072,6.072,0,0,1,6.372-6.065A6.29,6.29,0,0,1,87.98,107.2v15.715a6.3,6.3,0,0,0,5.7,6.173,6.067,6.067,0,0,0,6.355-6.076l.068-13.387a6.072,6.072,0,0,1,6.355-6.082,6.34,6.34,0,0,1,5.735,6.424V124.46a6.044,6.044,0,0,0,12.085-.2V106.993c0-2.629,1.952-5.041,5.524-5.041a4.813,4.813,0,0,1,5.109,4.768v16.892a6.287,6.287,0,0,0,5.667,6.424A6.126,6.126,0,0,0,147,123.96v-12.6c0-2.64,1.968-5.041,5.456-5.041a5.381,5.381,0,0,1,5.388,5.32v9.7a6.274,6.274,0,0,0,5.735,6.355,6.065,6.065,0,0,0,6.424-6.008V110.538a5.09,5.09,0,0,1,5.32-5.041h.2a5.091,5.091,0,0,1,5.32,5.041v12.318a6.34,6.34,0,0,0,5.735,6.424,6.072,6.072,0,0,0,6.355-6.082V86.869Z"
                transform="translate(-26.004 -55.013)"
              />
            </g>
          </g>
        </g>
        <g
          id="Trotinette"
          transform="translate(538.011)"
        >
          <ellipse
            id="Ellipse_118"
            data-name="Ellipse 118"
            class="cls-1"
            cx="47.536"
            cy="5.887"
            rx="47.536"
            ry="5.887"
            transform="translate(0 175.452)"
          />
          <path
            id="Tracé_2135"
            data-name="Tracé 2135"
            class="cls-4"
            d="M896.392,666.3a1.761,1.761,0,0,1-1.311-.793c-1.311-1.983-4.791-7.642-2.347-8.424a9.59,9.59,0,0,1,1.183-.29,12.044,12.044,0,0,1,11.676,4.563,11.281,11.281,0,0,1,.958,1.458,1.5,1.5,0,0,1-.9,2.165A28.7,28.7,0,0,1,896.392,666.3Z"
            transform="translate(-865.274 -500.434)"
          />
          <path
            id="Tracé_2136"
            data-name="Tracé 2136"
            class="cls-11"
            d="M816.767,541.192,830.1,538.78h19.959l-2.852,4.4H819.485Z"
            transform="translate(-788.064 -375.64)"
          />
          <path
            id="Tracé_2137"
            data-name="Tracé 2137"
            class="cls-12"
            d="M926.405,219.657c1.5-.76,3.446.008,5.227.18,2.308.224,4.593-.616,6.918-.541a8.659,8.659,0,0,1,5.673,2.343,6.93,6.93,0,0,1,2.088,4.755,5.53,5.53,0,0,1-.729,3.058c-1.106,1.847-3.619,3.1-6.252,3.3a11.705,11.705,0,0,1-7.3-1.915,36.723,36.723,0,0,1-4.375-4.078c-1.034-.97-3.76-2.2-3.781-3.46C923.854,222.433,925.462,220.136,926.405,219.657Z"
            transform="translate(-887.573 -195.535)"
          />
          <path
            id="Tracé_2138"
            data-name="Tracé 2138"
            class="cls-13"
            d="M926.405,219.657c1.5-.76,3.446.008,5.227.18,2.308.224,4.593-.616,6.918-.541a8.659,8.659,0,0,1,5.673,2.343,6.93,6.93,0,0,1,2.088,4.755,5.53,5.53,0,0,1-.729,3.058c-1.106,1.847-3.619,3.1-6.252,3.3a11.705,11.705,0,0,1-7.3-1.915,36.723,36.723,0,0,1-4.375-4.078c-1.034-.97-3.76-2.2-3.781-3.46C923.854,222.433,925.462,220.136,926.405,219.657Z"
            transform="translate(-887.573 -195.535)"
          />
          <path
            id="Tracé_2139"
            data-name="Tracé 2139"
            class="cls-12"
            d="M950.094,644.343l-.2,4.233a56.43,56.43,0,0,1,6.015-.114,4.5,4.5,0,0,0-.134-1.954,14.751,14.751,0,0,1-.243-3.792c.023-.349-3.726-.706-4.1-.722-.462-.02-.939-.081-1.16.4A5.835,5.835,0,0,0,950.094,644.343Z"
            transform="translate(-905.714 -490.237)"
          />
          <path
            id="Tracé_2140"
            data-name="Tracé 2140"
            class="cls-12"
            d="M933.789,648.853l-.2,4.233a56.432,56.432,0,0,1,6.015-.115,4.49,4.49,0,0,0-.134-1.954,14.759,14.759,0,0,1-.243-3.792c.023-.349-3.726-.706-4.1-.722-.461-.02-.939-.081-1.16.4A5.829,5.829,0,0,0,933.789,648.853Z"
            transform="translate(-894.346 -493.381)"
          />
          <path
            id="Tracé_2141"
            data-name="Tracé 2141"
            class="cls-12"
            d="M950.136,649.165a2.229,2.229,0,0,0-.769.481l-1.513,1.264c-.511.427-1.18.88-1.787.608a4.01,4.01,0,0,1-.708-.555.7.7,0,0,0-.83-.095.851.851,0,0,0-.232.525,40.23,40.23,0,0,0-.658,8.149,4.784,4.784,0,0,0,1.473.328.239.239,0,0,0,.164-.031c.09-.071.04-.21.028-.323-.042-.391.5-.622.857-.451a1.7,1.7,0,0,1,.7.92.927.927,0,0,0,.26.39.868.868,0,0,0,.359.132,13.279,13.279,0,0,0,2.085.189q4.845.17,9.695,0a3.216,3.216,0,0,0,.993-.141,1.888,1.888,0,0,0,1.155-1.467,2.6,2.6,0,0,0-.459-1.854,3.2,3.2,0,0,0-1.062-.976,6.358,6.358,0,0,0-1-.425l-1.525-.545a5.914,5.914,0,0,1-4.233-3.32C952.557,650.987,951.664,648.719,950.136,649.165Z"
            transform="translate(-901.349 -495.206)"
          />
          <path
            id="Tracé_2142"
            data-name="Tracé 2142"
            class="cls-13"
            d="M950.136,649.165a2.229,2.229,0,0,0-.769.481l-1.513,1.264c-.511.427-1.18.88-1.787.608a4.01,4.01,0,0,1-.708-.555.7.7,0,0,0-.83-.095.851.851,0,0,0-.232.525,40.23,40.23,0,0,0-.658,8.149,4.784,4.784,0,0,0,1.473.328.239.239,0,0,0,.164-.031c.09-.071.04-.21.028-.323-.042-.391.5-.622.857-.451a1.7,1.7,0,0,1,.7.92.927.927,0,0,0,.26.39.868.868,0,0,0,.359.132,13.279,13.279,0,0,0,2.085.189q4.845.17,9.695,0a3.216,3.216,0,0,0,.993-.141,1.888,1.888,0,0,0,1.155-1.467,2.6,2.6,0,0,0-.459-1.854,3.2,3.2,0,0,0-1.062-.976,6.358,6.358,0,0,0-1-.425l-1.525-.545a5.914,5.914,0,0,1-4.233-3.32C952.557,650.987,951.664,648.719,950.136,649.165Z"
            transform="translate(-901.349 -495.206)"
          />
          <path
            id="Tracé_2143"
            data-name="Tracé 2143"
            class="cls-11"
            d="M968.4,421.6c-.008.863-.025,1.731-.054,2.594a130.008,130.008,0,0,1-1.438,15.83c-.18,1.178-.377,2.351-.666,3.5a35.837,35.837,0,0,0-1.2,4.954c-.251,2.427.4,4.92-.151,7.3-.281,1.215-.867,2.339-1.224,3.537a19.285,19.285,0,0,0-.478,2.179l-.918,5.075-.093.518a20.838,20.838,0,0,1-1.987,5.723,18.181,18.181,0,0,0-1.2,3.507q-.811,3.005-1.618,6.018c-.729,2.712-1.463,5.541-.9,8.294a19.131,19.131,0,0,1-3.277-.478,18.619,18.619,0,0,1-3.977-1.458,134.008,134.008,0,0,1,.13-14.036,72,72,0,0,1,.767-8.86c.541-3.189,1.283-6.232,1.932-9.4.972-4.744,1.949-9.531,1.857-14.371-.117-6.27.046-12.657,2.783-18.3a4.185,4.185,0,0,1,1.266-1.714,4.338,4.338,0,0,1,1.815-.608,34.4,34.4,0,0,1,6.592-.474A4.627,4.627,0,0,1,968.4,421.6Z"
            transform="translate(-905.155 -336.115)"
          />
          <path
            id="Tracé_2144"
            data-name="Tracé 2144"
            class="cls-13"
            d="M968.4,421.6c-.008.863-6.553.2-6.582,1.068-8.049-.932-4.277.937-4.633,1.188-.763.536,2.9-.541,2.138,0-.662.469-1.693,2.291-2.376,2.736-1.6,1.044,3.725,4.258,2.539,5.75a6.931,6.931,0,0,0-1.182,4.9c.147,1.718.641,3.382.9,5.088a19.041,19.041,0,0,1-1,9.594,55.673,55.673,0,0,1-2.54,5.285c-.964,1.924-2.745,3.835-2.531,5.977.486,4.828-.356,9.686-.583,14.535a17,17,0,0,0,.432,5.528c.193.679.461,1.341.616,2.033a9.717,9.717,0,0,1-.4,4.87,18.613,18.613,0,0,1-3.977-1.458,133.91,133.91,0,0,1,.13-14.036,71.939,71.939,0,0,1,.767-8.86c.541-3.189,1.282-6.232,1.932-9.4.972-4.744,1.949-9.531,1.857-14.371-.117-6.27.046-12.657,2.783-18.3a4.185,4.185,0,0,1,1.266-1.714,4.336,4.336,0,0,1,1.815-.608,34.385,34.385,0,0,1,6.592-.474A4.629,4.629,0,0,1,968.4,421.6Z"
            transform="translate(-905.155 -336.115)"
          />
          <path
            id="Tracé_2145"
            data-name="Tracé 2145"
            class="cls-11"
            d="M946.759,396.165c.017,1.538.859,4.939-.318,5.929-.784.662-1.752,1.065-2.594,1.655-.763.536-1.412,1.224-2.175,1.764-.662.469-1.4.821-2.083,1.266-1.6,1.043-2.3,2.942-3.483,4.434a6.93,6.93,0,0,0-1.182,4.9c.147,1.718.641,3.382.9,5.088a19.035,19.035,0,0,1-1,9.593,55.606,55.606,0,0,1-2.54,5.285c-.964,1.924-2.745,3.835-2.532,5.977.486,4.828-.356,9.686-.583,14.535a17.007,17.007,0,0,0,.432,5.528c.193.679.461,1.341.616,2.033a10.817,10.817,0,0,1-.671,5.725,26.471,26.471,0,0,0-6.463-.587c-1.9.143-3.784.692-5.675.465a113.766,113.766,0,0,1,.7-15.289c.092-1.039.188-2.079.281-3.118.365-3.982.725-7.967.939-11.966.054-1.006-.3-2.075-.017-3.047q.88-3.049,1.769-6.1a15,15,0,0,0,.1-9.56l-1.823-8.768c-.2-.972-.4-1.949-.679-2.909a19.232,19.232,0,0,1-.511-1.932,24.39,24.39,0,0,1-.168-2.766c-.092-1.6-.465-3.16-.583-4.753a9.768,9.768,0,0,1,.071-2.293,5.776,5.776,0,0,1,.859-2.314,70.634,70.634,0,0,1,13.793-3.94,19.476,19.476,0,0,1,3.341-.39,22.31,22.31,0,0,1,3.8.423,19.087,19.087,0,0,1,5.134,1.391,7.626,7.626,0,0,1,2.087,1.454c.813.813.318-1.067.566.052A20.49,20.49,0,0,1,946.759,396.165Z"
            transform="translate(-883.027 -314.986)"
          />
          <path
            id="Tracé_2146"
            data-name="Tracé 2146"
            class="cls-12"
            d="M933.831,653.674a2.23,2.23,0,0,0-.769.481l-1.513,1.265c-.511.427-1.18.88-1.787.608a3.976,3.976,0,0,1-.708-.556.7.7,0,0,0-.83-.095.853.853,0,0,0-.233.526,40.223,40.223,0,0,0-.658,8.149,4.788,4.788,0,0,0,1.473.328.237.237,0,0,0,.163-.031c.089-.07.041-.21.029-.323-.042-.391.5-.622.857-.451a1.7,1.7,0,0,1,.7.92.929.929,0,0,0,.26.39.87.87,0,0,0,.36.132,13.224,13.224,0,0,0,2.085.189q4.846.171,9.695,0a3.212,3.212,0,0,0,.993-.141A1.888,1.888,0,0,0,945.1,663.6a2.6,2.6,0,0,0-.459-1.854,3.2,3.2,0,0,0-1.062-.976,6.376,6.376,0,0,0-1-.425l-1.525-.545a5.912,5.912,0,0,1-4.233-3.32C936.252,655.5,935.359,653.228,933.831,653.674Z"
            transform="translate(-889.981 -498.349)"
          />
          <path
            id="Tracé_2147"
            data-name="Tracé 2147"
            class="cls-14"
            d="M953.693,208.476a3,3,0,0,1-.633,1.3,5.459,5.459,0,0,1-2.439,2.23,4.917,4.917,0,0,1-1.819.163,23.89,23.89,0,0,1-14.33-5.7,7.883,7.883,0,0,0,3.16-5.8,19.084,19.084,0,0,0-.3-5.251c-.088-.511-.18-1.018-.273-1.521-.167-.926-.591-1.643.453-1.9a10.422,10.422,0,0,1,2.775-.013,9.435,9.435,0,0,1,5.226,1.635,3.492,3.492,0,0,1,1.006,1.1c.646,1.211.122,2.636-.029,4.028a5.542,5.542,0,0,0-.021.947,5.849,5.849,0,0,0,2.343,3.856c1.19.989,2.565,1.739,3.726,2.754A2.67,2.67,0,0,1,953.693,208.476Z"
            transform="translate(-894.965 -176.426)"
          />
          <path
            id="Tracé_2148"
            data-name="Tracé 2148"
            class="cls-13"
            d="M951.918,198.735a8.8,8.8,0,0,1-2.008.231,8.949,8.949,0,0,1-7.15-3.554c-.088-.511-.18-1.018-.273-1.521-.168-.926-.591-1.643.453-1.9a10.421,10.421,0,0,1,2.775-.013,9.436,9.436,0,0,1,5.226,1.635,3.5,3.5,0,0,1,1.006,1.1C952.593,195.919,952.069,197.344,951.918,198.735Z"
            transform="translate(-900.395 -176.426)"
          />
          <ellipse
            id="Ellipse_119"
            data-name="Ellipse 119"
            class="cls-14"
            cx="8.973"
            cy="8.973"
            rx="8.973"
            ry="8.973"
            transform="translate(40.545 4.177)"
          />
          <path
            id="Tracé_2149"
            data-name="Tracé 2149"
            class="cls-13"
            d="M947.618,394.7c-.055.121-.482,2.183-.549,2.3a32.488,32.488,0,0,0-7.883-.6,12.368,12.368,0,0,0-2.293.193c-.637.126-1.257.335-1.9.436-3.458.532-6.731-2.171-10.222-1.907a12.406,12.406,0,0,0-3.374.918c-1.22.461-2.406.813-3.6,1.22a5.776,5.776,0,0,1,.859-2.314,70.651,70.651,0,0,1,13.793-3.94,19.477,19.477,0,0,1,3.34-.39,22.312,22.312,0,0,1,3.8.423,19.089,19.089,0,0,1,5.134,1.392,7.623,7.623,0,0,1,2.087,1.454C947.618,394.7,947.37,393.581,947.618,394.7Z"
            transform="translate(-883.337 -314.986)"
          />
          <path
            id="Tracé_2150"
            data-name="Tracé 2150"
            class="cls-4"
            d="M901.722,227.757a5.287,5.287,0,0,0-1.418-2.317q-1.732-1.941-3.58-3.775a5.146,5.146,0,0,0-1.394-1.089,1.814,1.814,0,0,0-1.7.015c-.465.294-.7.835-1.074,1.241-.807.882-2.209,1.09-2.887,2.075a5.341,5.341,0,0,1-.517.784,2.306,2.306,0,0,1-1.015.5l-4.276,1.28a2,2,0,0,0-1.3.809,2.65,2.65,0,0,0-.19.778c-.338,1.936-2.045,3.279-3.543,4.551a3.838,3.838,0,0,0-1.267,1.566,3.772,3.772,0,0,0,.029,1.977,12.917,12.917,0,0,0,1.8,4.729,28.847,28.847,0,0,1,2.014,2.767,9.508,9.508,0,0,1,.836,3.058c.289,1.989.459,3.993.629,6,.15,1.763-.062,3.745.448,5.439.625,2.075,2.851,3.254,3.839,5.183a9.684,9.684,0,0,1,.759,2.549l.962,4.812a10.587,10.587,0,0,1,.283,2.222c-.027,1.764-.931,3.485-.645,5.226,1.6-.6,3.145-1.02,4.745-1.625a12.285,12.285,0,0,1,3.378-.921c3.487-.262,6.763,2.44,10.219,1.907.642-.1,1.262-.308,1.9-.435a12.76,12.76,0,0,1,2.292-.195,43.124,43.124,0,0,1,9.073.821,5.4,5.4,0,0,0,.555-3.432,27.685,27.685,0,0,0-.823-3.442,25.5,25.5,0,0,1-.659-9.23,20.353,20.353,0,0,0,.207-2.341c-.011-2.925-1.773-5.666-1.609-8.586.16-2.875,3.444-4.484,4.8-7.026a3.011,3.011,0,0,0,.452-1.691,6.247,6.247,0,0,0-.693-1.72c-.6-1.395-.38-3-.728-4.48-.122-.518-.313-1.018-.427-1.537-.315-1.437-.028-2.962-.4-4.386a8.315,8.315,0,0,0-1.645-2.961,12.7,12.7,0,0,0-4.307-3.762,6.214,6.214,0,0,0-5.556-.1,2.053,2.053,0,0,0-.685.542,2.726,2.726,0,0,0-.375.883,27.361,27.361,0,0,1-2.487,5.793,2.689,2.689,0,0,1-2.2-.659C902.932,229.048,901.883,228.532,901.722,227.757Z"
            transform="translate(-855.198 -196.289)"
          />
          <path
            id="Tracé_2151"
            data-name="Tracé 2151"
            class="cls-11"
            d="M933.972,156.677a2.9,2.9,0,0,0,.217-1.271,2.016,2.016,0,0,1,.34-1.231c.349-.425.98-.54,1.317-.974.382-.493.255-1.194.369-1.807a2.279,2.279,0,0,1,2.1-1.8,10.057,10.057,0,0,1,2.194.48,7.952,7.952,0,0,0,2.913-.151,3.15,3.15,0,0,0,1.964-.85,2.976,2.976,0,0,0,.519-1.285,3.019,3.019,0,0,0-.091-2.168c-.376-.643-1.161-.95-1.573-1.57-.361-.543-.39-1.257-.757-1.8a2.845,2.845,0,0,0-2.766-.862,9.1,9.1,0,0,1-3.025.233c-1.1-.236-2.18-1.1-3.212-.666-.759.32-1.077,1.2-1.542,1.875a4.09,4.09,0,0,1-1.6,1.371c-.987.475-2.144.542-3.091,1.093a3.453,3.453,0,0,0-1.639,2.349,1.015,1.015,0,0,0,.018.541,2.345,2.345,0,0,0,.241.383,2.055,2.055,0,0,1-.242,2.087,5.951,5.951,0,0,0-1.013,1.952,3.216,3.216,0,0,0,.541,2.1,15.668,15.668,0,0,1,1.118,1.913c.321.788.382,1.664.707,2.451a3.971,3.971,0,0,0,2.965,2.356.908.908,0,0,0,.724-.109.941.941,0,0,0,.268-.515,5.971,5.971,0,0,0,.171-1.022,5.743,5.743,0,0,1,.3-2.089C932.8,156.912,933.566,157.443,933.972,156.677Z"
            transform="translate(-888.773 -140.836)"
          />
          <path
            id="Tracé_2152"
            data-name="Tracé 2152"
            class="cls-13"
            d="M953.449,147.113c-.376-.643-1.16-.95-1.573-1.57-.361-.543-.391-1.257-.757-1.8a1.985,1.985,0,0,0-1.133-.767l0,.006c.366.54.4,1.254.757,1.8.413.62,1.2.927,1.573,1.57a3.017,3.017,0,0,1,.091,2.168,2.974,2.974,0,0,1-.519,1.285,3.15,3.15,0,0,1-1.964.85,7.954,7.954,0,0,1-2.913.151,10.049,10.049,0,0,0-2.194-.479,2.279,2.279,0,0,0-2.1,1.8c-.115.613.013,1.314-.369,1.807-.337.434-.968.55-1.317.974a2.017,2.017,0,0,0-.34,1.231,2.9,2.9,0,0,1-.217,1.271c-.406.767-1.169.235-1.556,1.02a5.748,5.748,0,0,0-.3,2.089,5.942,5.942,0,0,1-.171,1.022.938.938,0,0,1-.269.515.907.907,0,0,1-.724.109,3.771,3.771,0,0,1-.917-.278,3.935,3.935,0,0,0,2.046,1.04.907.907,0,0,0,.724-.109.938.938,0,0,0,.269-.515,5.942,5.942,0,0,0,.171-1.022,5.751,5.751,0,0,1,.3-2.089c.387-.784,1.15-.253,1.556-1.02a2.9,2.9,0,0,0,.217-1.271,2.014,2.014,0,0,1,.34-1.231c.349-.424.98-.54,1.317-.974.382-.492.254-1.194.37-1.807a2.278,2.278,0,0,1,2.1-1.8,10.047,10.047,0,0,1,2.194.479,7.954,7.954,0,0,0,2.913-.151,3.15,3.15,0,0,0,1.964-.85,2.976,2.976,0,0,0,.519-1.285A3.018,3.018,0,0,0,953.449,147.113Z"
            transform="translate(-896.403 -142.33)"
          />
          <path
            id="Tracé_2153"
            data-name="Tracé 2153"
            class="cls-11"
            d="M906.458,697.841c0,3.055-2.138,5.532-4.774,5.532s-4.77-2.477-4.77-5.532V697.8c.021-3.034,2.15-5.49,4.77-5.49a4.6,4.6,0,0,1,3.91,2.368,6.077,6.077,0,0,1,.863,3.164Z"
            transform="translate(-868.78 -525.326)"
          />
          <path
            id="Tracé_2154"
            data-name="Tracé 2154"
            class="cls-11"
            d="M1022.711,693.412c0,5.884-3.043,10.654-6.794,10.654s-6.79-4.769-6.79-10.654a13.608,13.608,0,0,1,2.49-8.244,5.543,5.543,0,0,1,4.3-2.41,4.445,4.445,0,0,1,.671.05,5.794,5.794,0,0,1,3.584,2.3c.138.172.268.352.394.54A13.964,13.964,0,0,1,1022.711,693.412Z"
            transform="translate(-947.015 -518.667)"
          />
          <path
            id="Tracé_2155"
            data-name="Tracé 2155"
            class="cls-11"
            d="M918.678,320.188l-5.939.591-.763-6.345-.05-.415-1.077-8.944-.05-.415-5.453-45.247-.117-.964-3.252-27-.08-.646-.34-2.825-.226-1.873h4.753l.26,1.94.042.31.117.868,4.078,30.482.109.817,5.817,43.453,1.274,9.522Z"
            transform="translate(-847.022 -157.639)"
          />
          <path
            id="Tracé_2156"
            data-name="Tracé 2156"
            class="cls-13"
            d="M1021.649,682.758a4.444,4.444,0,0,1,.671.05c-.054.038-.113.076-.168.113a3.812,3.812,0,0,0-1.521,3.529l.964,9.158c0,.046.008.1.008.143a1.38,1.38,0,0,1-2.737.26c-.4-2.1-1.149-6.387-1.488-10.26-.017-.205-.029-.4-.029-.583A5.544,5.544,0,0,1,1021.649,682.758Z"
            transform="translate(-952.747 -518.667)"
          />
          <path
            id="Tracé_2157"
            data-name="Tracé 2157"
            class="cls-13"
            d="M1036.3,691.064l-.21-.059c-.063-.168-.121-.331-.184-.482C1036.049,690.7,1036.179,690.875,1036.3,691.064Z"
            transform="translate(-965.688 -524.081)"
          />
          <path
            id="Tracé_2158"
            data-name="Tracé 2158"
            class="cls-15"
            d="M1020.337,674.408s-4.831-.317-4.356,5.069c.342,3.874,1.093,8.157,1.488,10.257a1.38,1.38,0,0,0,1.563,1.108h0a1.381,1.381,0,0,0,1.167-1.51l-.964-9.156a3.812,3.812,0,0,1,1.522-3.53c1.14-.8,2.663-.85,3.936,2.672l.871.238S1026.673,673.774,1020.337,674.408Z"
            transform="translate(-951.77 -512.811)"
          />
          <path
            id="Tracé_2159"
            data-name="Tracé 2159"
            class="cls-13"
            d="M993.34,405.513a3.837,3.837,0,0,1-.729.071h-1.7a3.907,3.907,0,0,1-3.872-3.474l-2.6-23.7a3.9,3.9,0,0,1,4.711-4.246Z"
            transform="translate(-929.781 -303.451)"
          />
          <path
            id="Tracé_2160"
            data-name="Tracé 2160"
            class="cls-13"
            d="M994.2,408.255a3.738,3.738,0,0,1-.838.092h-1.7a3.867,3.867,0,0,1-2.8-1.2l-.117-.964-3.252-27a3.881,3.881,0,0,1,4.526-2.226l4.078,30.482Z"
            transform="translate(-930.532 -305.375)"
          />
          <path
            id="Tracé_2161"
            data-name="Tracé 2161"
            class="cls-4"
            d="M984.43,379.765l2.6,23.706a3.9,3.9,0,0,0,3.874,3.469h1.7a3.827,3.827,0,0,0,3.68-2.613,3.372,3.372,0,0,0,.158-1.011c0-1.806-1.949-18.274-2.555-23.349a3.842,3.842,0,0,0-1.436-2.576,13.587,13.587,0,0,0-2.576-1.616A3.886,3.886,0,0,0,984.43,379.765Z"
            transform="translate(-929.779 -304.388)"
          />
          <path
            id="Tracé_2162"
            data-name="Tracé 2162"
            class="cls-16"
            d="M984.43,379.765l2.6,23.706a3.9,3.9,0,0,0,3.874,3.469h1.7a3.827,3.827,0,0,0,3.68-2.613,3.372,3.372,0,0,0,.158-1.011c0-1.806-1.949-18.274-2.555-23.349a3.842,3.842,0,0,0-1.436-2.576,13.587,13.587,0,0,0-2.576-1.616A3.886,3.886,0,0,0,984.43,379.765Z"
            transform="translate(-929.779 -304.388)"
          />
          <path
            id="Tracé_2163"
            data-name="Tracé 2163"
            class="cls-13"
            d="M905.594,694.677l-1.278-.054a5.962,5.962,0,0,0-3.248.8l-4,2.3a1.337,1.337,0,0,1-.155.08c.021-3.034,2.15-5.49,4.769-5.49A4.6,4.6,0,0,1,905.594,694.677Z"
            transform="translate(-868.78 -525.326)"
          />
          <path
            id="Tracé_2164"
            data-name="Tracé 2164"
            class="cls-13"
            d="M939.7,494.182l-5.8.52-.05-.415-1.077-8.944,5.658-.683Z"
            transform="translate(-868.938 -337.908)"
          />
          <path
            id="Tracé_2165"
            data-name="Tracé 2165"
            class="cls-15"
            d="M926.853,634.158c.93,13.638-8.609,13.374-8.609,13.374l-20.753-.878a6,6,0,0,0-3.251.8l-4,2.3a2.081,2.081,0,0,1-2.333-.172h0a2.081,2.081,0,0,1-.371-2.879l1.69-2.253a3.526,3.526,0,0,1,3.021-1.4l21.713,1.238c8.793.159,11.76-19.485,11.76-19.485h0l5.708-.687,1.274,9.522-5.855.524Z"
            transform="translate(-861.954 -477.779)"
          />
          <path
            id="Tracé_2166"
            data-name="Tracé 2166"
            class="cls-13"
            SvgProgramIntroWeb
            d="M906.343,228.042l-4.786-.067-.226-1.873h4.753Z"
            transform="translate(-847.022 -157.639)"
          />
          <path
            id="Tracé_2167"
            data-name="Tracé 2167"
            class="cls-11"
            d="M920.691,361.133l40.142,1.006a1.254,1.254,0,0,1,1.223,1.254h0a1.253,1.253,0,0,1-1.271,1.254l-40.142-.559a1.254,1.254,0,0,1-1.236-1.254v-.447a1.254,1.254,0,0,1,1.285-1.254Z"
            transform="translate(-884.461 -294.428)"
          />
          <path
            id="Tracé_2168"
            data-name="Tracé 2168"
            class="cls-14"
            d="M916.689,347c1.4.284,2.947.21,4.117,1.029a4.242,4.242,0,0,1,1.607,3.322,12.554,12.554,0,0,1-.607,3.759c-.1.389-.306.86-.708.87-.377.01-.609-.4-.932-.593-.695-.422-1.681.2-2.381-.209a3.7,3.7,0,0,1-.551-.5,1.825,1.825,0,0,0-2.04-.241,3.268,3.268,0,0,0-3.307-3.872,3.114,3.114,0,0,1-1.6-.1c-.766-.42-.7-1.569-.289-2.339.58-1.08,1.024-2.142,2.344-2.139C913.842,345.989,915.237,346.708,916.689,347Z"
            transform="translate(-877.689 -283.868)"
          />
          <path
            id="Tracé_2169"
            data-name="Tracé 2169"
            class="cls-14"
            d="M1023.058,346.4l-.018,2.943a6.429,6.429,0,0,0,.546,3.236,1.655,1.655,0,0,0,1.357.947c.218,0,.431-.073.648-.065.635.024,1.206.691,1.8.469.2-.075.36-.245.567-.307.308-.092.651.078.958-.018s.486-.444.615-.754c.614-1.478,1.225-3.1.771-4.639a7.157,7.157,0,0,0-1.031-1.922l-1.963-2.9a1.01,1.01,0,0,0-.321-.343.876.876,0,0,0-.439-.08,6.551,6.551,0,0,0-2.758.9C1022.95,344.281,1023.063,345.56,1023.058,346.4Z"
            transform="translate(-956.714 -281.758)"
          />
          <path
            id="Tracé_2170"
            data-name="Tracé 2170"
            class="cls-4"
            d="M1012.931,292.136a8.437,8.437,0,0,0,.55,1.881,7.167,7.167,0,0,1,1.067,2.027c.13.905-.463,1.956.1,2.675.232.3.613.444.85.736.58.715.027,1.772.111,2.689.078.84.7,1.537.875,2.363.179.854-.117,1.85.411,2.546a2.633,2.633,0,0,0-2.7-.846,6.113,6.113,0,0,0-4.018,2.6,7.976,7.976,0,0,0-.376-3.561,8.655,8.655,0,0,1-.873-3.1,13.992,13.992,0,0,0,.218-1.906,4.4,4.4,0,0,0-1.611-2.465,5.106,5.106,0,0,1-1.772-3.065,4.753,4.753,0,0,1,1.185-3.071,5.839,5.839,0,0,1,2-1.814c.531-.26,2.136-1.351,2.488-1.216C1012.18,288.9,1012.766,291.445,1012.931,292.136Z"
            transform="translate(-944.666 -243.859)"
          />
          <path
            id="Tracé_2171"
            data-name="Tracé 2171"
            class="cls-4"
            d="M861.817,270.176a3.441,3.441,0,0,0-1.925,1.6,13.075,13.075,0,0,0-1.007,2.349,31.039,31.039,0,0,1-2.364,4.988,16.977,16.977,0,0,0-1.894,3.712,18.8,18.8,0,0,1-.93,3.519,14.685,14.685,0,0,0-.879,1.548,5.113,5.113,0,0,0-.127,2.29l.2,2.049a3.926,3.926,0,0,0,2.183,3.646l3.079,2.185a7.989,7.989,0,0,0,1.926,1.113c2.007.7,4.167-.267,6.276-.533a18.921,18.921,0,0,1,4.379.129,6.024,6.024,0,0,1,.5-3.5c.574-1.049,2.33-2.43,3.489-2.135-1.152-.974-3.056-.432-4.331-1.238-.512-.324-.947-.757-1.449-1.1-1.585-1.072-3.856-1.256-4.877-2.875a.672.672,0,0,1-.121-.3c-.017-.24.186-.432.361-.6a7.315,7.315,0,0,0,2.075-4.705,19.323,19.323,0,0,0-.441-5.223,15.1,15.1,0,0,0-1.174-4.047A5.544,5.544,0,0,0,861.817,270.176Z"
            transform="translate(-837.901 -231.013)"
          />
        </g>
        <g
          id="Bike"
          transform="translate(199.999 10.314)"
        >
          <path
            id="Tracé_2176"
            data-name="Tracé 2176"
            class="cls-17"
            d="M594.024,501.776l2.221,49.747s-5.774,47.082-4.442,48.414,4.886,4,2.221,7.107-12.437,5.33-12.881,3.553-1.332-52.412-1.332-52.412L576.7,498.222Z"
            transform="translate(-391.686 -438.38)"
          />
          <path
            id="Tracé_2177"
            data-name="Tracé 2177"
            class="cls-18"
            d="M594.024,501.776l2.221,49.747s-5.774,47.082-4.442,48.414,4.886,4,2.221,7.107-12.437,5.33-12.881,3.553-1.332-52.412-1.332-52.412L576.7,498.222Z"
            transform="translate(-391.686 -438.38)"
          />
          <path
            id="Tracé_2178"
            data-name="Tracé 2178"
            class="cls-17"
            d="M553.043,741.222s11.1,8.439,12.437,8.439,13.325,4,4.886,5.774-28.871.888-29.315-1.777,1.332-10.753,1.332-10.753Z"
            transform="translate(-352.925 -573.447)"
          />
          <path
            id="Tracé_2179"
            data-name="Tracé 2179"
            class="cls-18"
            d="M553.043,741.222s11.1,8.439,12.437,8.439,13.325,4,4.886,5.774-28.871.888-29.315-1.777,1.332-10.753,1.332-10.753Z"
            transform="translate(-352.925 -573.447)"
          />
          <path
            id="Tracé_2180"
            data-name="Tracé 2180"
            class="cls-4"
            d="M495.767,422.222s4.886,1.777,4.886,3.109,4.442,18.211,5.33,19.1,1.332,4.886,1.332,4.886,4.442,10.216,3.553,10.216-8.439-1.777-8.883,0-4-11.1-4-11.1l-7.551-15.1Z"
            transform="translate(-268.112 -396.137)"
          />
          <path
            id="Tracé_2181"
            data-name="Tracé 2181"
            class="cls-19"
            d="M497.167,508s-1.333,9.772-4.886,10.66,0-12.437,0-12.437Z"
            transform="translate(-254.409 -442.826)"
          />
          <path
            id="Tracé_2182"
            data-name="Tracé 2182"
            class="cls-19"
            d="M534.469,401.975s-2.665,5.774-4,8.883-13.769-8-13.769-8,6.663-4.886,6.663-7.107S534.469,401.975,534.469,401.975Z"
            transform="translate(-303.259 -381.219)"
          />
          <path
            id="Tracé_2185"
            data-name="Tracé 2185"
            class="cls-17"
            d="M416.121,675.061A40.419,40.419,0,1,0,375.7,634.642a40.419,40.419,0,0,0,40.419,40.419Zm0-79.95a39.531,39.531,0,1,1-39.531,39.531A39.531,39.531,0,0,1,416.121,595.111Z"
            transform="translate(-162.703 -491.74)"
          />
          <path
            id="Tracé_2186"
            data-name="Tracé 2186"
            class="cls-17"
            d="M696.121,675.061A40.419,40.419,0,1,0,655.7,634.642a40.419,40.419,0,0,0,40.419,40.419Zm0-79.95a39.531,39.531,0,1,1-39.531,39.531A39.531,39.531,0,0,1,696.121,595.111Z"
            transform="translate(-567.071 -491.74)"
          />
          <ellipse
            id="Ellipse_120"
            data-name="Ellipse 120"
            class="cls-17"
            cx="2.665"
            cy="2.665"
            rx="2.665"
            ry="2.665"
            transform="translate(250.753 140.237)"
          />
          <ellipse
            id="Ellipse_121"
            data-name="Ellipse 121"
            class="cls-17"
            cx="2.665"
            cy="2.665"
            rx="2.665"
            ry="2.665"
            transform="translate(125.497 140.237)"
          />
          <path
            id="Tracé_2187"
            data-name="Tracé 2187"
            class="cls-17"
            d="M463.359,484.744l.817-.349-23.214-54.464-65.83,1.343-.127.2L342.58,482.109l.748.479,32.3-50.436,64.755-1.322Z"
            transform="translate(-213.903 -345.665)"
          />
          <path
            id="Tracé_2188"
            data-name="Tracé 2188"
            class="cls-17"
            d="M546.1,500.837l-17.062-60.165-.854.242,16.695,58.872L500.237,494.1l-.112.882Z"
            transform="translate(-365.8 -351.635)"
          />
          <rect
            id="Rectangle_1049"
            data-name="Rectangle 1049"
            class="cls-17"
            width="0.888"
            height="65.331"
            transform="translate(183.556 144.987) rotate(-135.551)"
          />
          <rect
            id="Rectangle_1050"
            data-name="Rectangle 1050"
            class="cls-17"
            width="10.129"
            height="0.888"
            transform="translate(160.601 84.83) rotate(-105.23)"
          />
          <path
            id="Tracé_2189"
            data-name="Tracé 2189"
            class="cls-17"
            d="M386.844,405.145l.867-.2-2.1-9.229h7.438v-5.774h-.888v4.886H384.5Z"
            transform="translate(-161.398 -323.44)"
          />
          <path
            id="Tracé_2190"
            data-name="Tracé 2190"
            class="cls-17"
            d="M674.974,510.088s0-2.665-5.774-1.332-23.541,4.886-24.874,4.442-.888,2.665,4.886,4,12.437-1.777,13.769-2.665S674.974,510.088,674.974,510.088Z"
            transform="translate(-500.174 -444.027)"
          />
          <rect
            id="Rectangle_1051"
            data-name="Rectangle 1051"
            class="cls-4"
            width="11.548"
            height="4.442"
            transform="translate(190.79 145.567)"
          />
          <path
            id="Tracé_2191"
            data-name="Tracé 2191"
            class="cls-17"
            d="M621.585,695.989a8.883,8.883,0,1,0-8.883-8.883A8.883,8.883,0,0,0,621.585,695.989Zm0-16.878a8,8,0,1,1-8,8A8,8,0,0,1,621.585,679.111Z"
            transform="translate(-441.9 -538.429)"
          />
          <ellipse
            id="Ellipse_122"
            data-name="Ellipse 122"
            class="cls-19"
            cx="10.66"
            cy="10.66"
            rx="10.66"
            ry="10.66"
            transform="translate(216.552 3.877)"
          />
          <path
            id="Tracé_2192"
            data-name="Tracé 2192"
            class="cls-17"
            d="M556.311,500.564s30.648,17.767,30.2,23.541-23.541,37.31-23.541,37.31-1.777,9.328-3.553,9.328-12.881,4-13.325,1.332,3.554-5.774,3.109-7.551,19.543-34.2,19.543-34.2-42.776-15.99-33.825-29.759S556.311,500.564,556.311,500.564Z"
            transform="translate(-362.856 -436.28)"
          />
          <path
            id="Tracé_2193"
            data-name="Tracé 2193"
            class="cls-17"
            d="M574.11,662.222s5.33,1.333,6.219,3.109,16.434,7.551,11.992,8.883-30.2,1.777-31.092.888,0-11.2,3.554-11.151S572.333,665.331,574.11,662.222Z"
            transform="translate(-381.543 -529.536)"
          />
          <path
            id="Tracé_2194"
            data-name="Tracé 2194"
            class="cls-4"
            d="M574.465,416.895l-9.994-12.215s-11.326-3.331-16.212,3.331-18.211,23.1-22.653,26.65-10.66,17.323-8.439,17.767,14.658-4.886,19.543-1.332,14.214,4,14.657,2.221,27.094-31.536,27.094-35.533-2.84-4.855-2.84-4.855Z"
            transform="translate(-347.253 -385.923)"
          />
          <rect
            id="Rectangle_1052"
            data-name="Rectangle 1052"
            class="cls-17"
            width="16.878"
            height="2.665"
            rx="1.332"
            transform="matrix(-0.943, 0.333, -0.333, -0.943, 237.389, 63.615)"
          />
          <path
            id="Tracé_2195"
            data-name="Tracé 2195"
            class="cls-19"
            d="M438.852,500.222s15.546,4.442,14.213,9.328-15.546-5.774-15.546-5.774Z"
            transform="translate(-186.767 -439.491)"
          />
          <path
            id="Tracé_2196"
            data-name="Tracé 2196"
            class="cls-4"
            d="M475.023,413.024s6.218,5.33,7.551,11.548,8,17.323,8,17.323l27.094,8.883s1.777,8.439-.888,8.439S484.35,453,483.462,451.667s-19.987-26.65-19.987-26.65S461.7,411.248,475.023,413.024Z"
            transform="translate(-263.356 -390.936)"
          />
          <path
            id="Tracé_2197"
            data-name="Tracé 2197"
            class="cls-17"
            d="M517.515,365.692a2.1,2.1,0,0,0,.916.459.653.653,0,0,0,.757-.524,2.714,2.714,0,0,0,1.039,1.332c.509.265,1.295.043,1.368-.526a2.4,2.4,0,0,0,.553,1.166.828.828,0,0,0,1.163.039,29.867,29.867,0,0,0-.155,3.7,4.717,4.717,0,0,1-1.333,3.358c-1.361,1.185-3.408.892-5.2.668a1.58,1.58,0,0,0-.815.045c-.671.286-.64,1.219-.649,1.948a5.412,5.412,0,0,1-4.739,5.139,2.713,2.713,0,0,1-2.016-.492c-.508-.431-.768-1.133-1.351-1.457-.948-.526-2.1.242-2.79,1.075s-1.376,1.86-2.449,2.012c-1.419.2-2.5-1.245-3.031-2.577a15.023,15.023,0,0,1,.3-11.673C502.046,362.928,512.171,361.906,517.515,365.692Z"
            transform="translate(-283.682 -363.493)"
          />
          <rect
            id="Rectangle_1056"
            data-name="Rectangle 1056"
            class="cls-17"
            width="402.572"
            transform="translate(0 182.838)"
          />
        </g>
        <g
          id="Covoiturage"
          transform="translate(0 44.27)"
        >
          <ellipse
            id="Ellipse_175"
            data-name="Ellipse 175"
            class="cls-1"
            cx="123.079"
            cy="11.403"
            rx="123.079"
            ry="11.403"
            transform="translate(0.192 125.58)"
          />
          <g
            id="Groupe_666"
            data-name="Groupe 666"
            transform="translate(0 0)"
          >
            <rect
              id="Rectangle_1215"
              data-name="Rectangle 1215"
              class="cls-20"
              width="28.306"
              height="4.493"
              transform="translate(0.746 108.952)"
            />
            <path
              id="Tracé_2409"
              data-name="Tracé 2409"
              class="cls-4"
              d="M650.78,585.009l-5.84,1.351-221.953.118-2-4.65a46.937,46.937,0,0,1-3.451-25.38c.956-6.422,3.351-12.8,8.792-15.576l9.85-65.6,122.8-.22,47.509,38.319s22.411-.4,34.586,14.754c3.853,4.8,6.683,11.162,7.442,19.595l.48,7.885Z"
              transform="translate(-417.073 -475.05)"
            />
            <ellipse
              id="Ellipse_165"
              data-name="Ellipse 165"
              class="cls-20"
              cx="27.407"
              cy="27.407"
              rx="27.407"
              ry="27.407"
              transform="translate(157.55 81.454)"
            />
            <ellipse
              id="Ellipse_166"
              data-name="Ellipse 166"
              class="cls-21"
              cx="14.425"
              cy="14.425"
              rx="14.425"
              ry="14.425"
              transform="translate(170.533 94.437)"
            />
            <ellipse
              id="Ellipse_167"
              data-name="Ellipse 167"
              class="cls-20"
              cx="27.407"
              cy="27.407"
              rx="27.407"
              ry="27.407"
              transform="translate(22.312 81.527)"
            />
            <ellipse
              id="Ellipse_168"
              data-name="Ellipse 168"
              class="cls-21"
              cx="14.425"
              cy="14.425"
              rx="14.425"
              ry="14.425"
              transform="translate(35.294 94.509)"
            />
            <path
              id="Tracé_2410"
              data-name="Tracé 2410"
              class="cls-22"
              d="M451.089,339.583l-66.3.029H376.7l-13.665.01v-1l-.01-12.016-.01-13.492h9.09l8.093-.01,14.337-.009h8.093l16.551-.01Z"
              transform="translate(-280.552 -305.743)"
            />
            <path
              id="Tracé_2411"
              data-name="Tracé 2411"
              class="cls-22"
              d="M350.427,339.632l-35.039.019-.01-6.875V320.761l-.01-7.614H320.5l8.093-.01,21.825-.01Z"
              transform="translate(-278.735 -305.744)"
            />
            <rect
              id="Rectangle_1216"
              data-name="Rectangle 1216"
              class="cls-20"
              width="4.493"
              height="8.537"
              transform="translate(82.49 53.651)"
            />
            <rect
              id="Rectangle_1217"
              data-name="Rectangle 1217"
              class="cls-20"
              width="4.493"
              height="8.537"
              transform="matrix(0.001, 1, -1, 0.001, 161.106, 41.478)"
            />
            <path
              id="Tracé_2412"
              data-name="Tracé 2412"
              class="cls-20"
              d="M439.169,331.106h.494a9.39,9.39,0,0,1,9.39,9.39h0a9.39,9.39,0,0,1-9.39,9.39h-.494Z"
              transform="translate(-283.456 -306.43)"
            />
            <path
              id="Tracé_2413"
              data-name="Tracé 2413"
              class="cls-20"
              d="M657.552,557.707a14.514,14.514,0,0,1-7.923-27.479c3.853,4.8,6.682,11.161,7.442,19.594Z"
              transform="translate(-425.63 -477.154)"
            />
            <path
              id="Tracé_2416"
              data-name="Tracé 2416"
              class="cls-23"
              d="M403.168,313.1l-17.836,26.514h-8.093L395.075,313.1Z"
              transform="translate(-281.095 -305.743)"
            />
            <path
              id="Tracé_2414"
              data-name="Tracé 2414"
              class="cls-23"
              d="M380.2,313.108l-17.165,25.517-.009-12.016,9.081-13.492Z"
              transform="translate(-280.552 -305.744)"
            />
            <path
              id="Tracé_2415"
              data-name="Tracé 2415"
              class="cls-23"
              d="M328.593,313.138l-13.214,19.639V320.762l5.121-7.614Z"
              transform="translate(-278.735 -305.745)"
            />
            <ellipse
              id="Ellipse_170"
              data-name="Ellipse 170"
              class="cls-2"
              cx="12.451"
              cy="11.99"
              rx="12.451"
              ry="11.99"
              transform="translate(111.691 10.55)"
            />
            <ellipse
              id="Ellipse_169"
              data-name="Ellipse 169"
              class="cls-2"
              cx="12.451"
              cy="11.99"
              rx="12.451"
              ry="11.99"
              transform="translate(39.752 10.55)"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Composant_116_1"
      data-name="Composant 116 – 1"
      transform="translate(904.002 44)"
    >
      <g
        id="Composant_113_1"
        data-name="Composant 113 – 1"
        transform="translate(0 0)"
      >
        <g id="earth">
          <rect
            id="accent"
            class="cls-4"
            width="11.98"
            height="34.876"
            transform="translate(61.67 78.466) rotate(-49.171)"
          />
          <rect
            id="accent-2"
            data-name="accent"
            class="cls-4"
            width="11.98"
            height="30.914"
            transform="translate(231.31 240.579) rotate(-49.171)"
          />
          <path
            id="Tracé_2220"
            data-name="Tracé 2220"
            class="cls-20"
            d="M234.815,117.41v.7q-.024,2.648-.152,5.271A117.407,117.407,0,0,1,.24,124.918Q0,121.192,0,117.41A116.826,116.826,0,0,1,21.589,49.546q1.689-2.4,3.514-4.7c.839-1.07,1.7-2.117,2.572-3.155A117.429,117.429,0,0,1,191.294,26.16c1.414,1.142,2.8,2.324,4.161,3.53q1.629,1.45,3.2,2.963a117.09,117.09,0,0,1,35.749,74.885Q234.815,112.427,234.815,117.41Z"
            transform="matrix(0.809, -0.588, 0.588, 0.809, 0, 138.021)"
          />
          <path
            id="accent-3"
            data-name="accent"
            class="cls-4"
            d="M611.683,622.206c-72.886,0-132.183-59.3-132.183-132.183a131.751,131.751,0,0,1,35.27-89.89l2.927,2.717A128.19,128.19,0,0,0,703.709,579.263l2.867,2.78A131.138,131.138,0,0,1,611.683,622.206Z"
            transform="translate(-447.684 -326.026)"
          />
          <rect
            id="accent-4"
            data-name="accent"
            class="cls-4"
            width="33.545"
            height="33.545"
            transform="translate(149.623 293.385)"
          />
          <path
            id="accent-5"
            data-name="accent"
            class="cls-4"
            d="M25.1,3.155a.655.655,0,0,1,.16.1c.631.519-.16,1.518-.064,2.34.112,1.054,1.517,1.286,2.58,1.39s2.4.966,1.9,1.909c-2.668.919-5.367.016-8.091-1.03A116.826,116.826,0,0,0,0,75.724q0,3.786.24,7.508a3.034,3.034,0,0,0,.727.391,15.523,15.523,0,0,1,2.46.679c.583.344.974.951,1.557,1.27,1.669.91,3.985-.839,5.543.248a14.321,14.321,0,0,1,1.142,1.166c1.438,1.246,3.8.407,5.463,1.342a6.482,6.482,0,0,1,2.2,2.883c1.43,2.716,3.746,5.383,6.8,5.6a18.315,18.315,0,0,1,2.891.1c.942.216,1.869,1.038,1.717,1.989-.263,1.637.543,3.426.327,5.064-.391,3-4.632,4.305-4.992,7.3a17.993,17.993,0,0,1-.112,1.973c-.192.783-.783,1.422-.99,2.2-.4,1.478.663,2.955,1.821,3.946s2.556,1.861,3.195,3.251c.671,1.478.344,3.195.559,4.8.479,3.506,3.506,6.1,6.621,7.779a6.914,6.914,0,0,1,2.588,1.885c.8,1.158.719,2.684.99,4.065.655,3.378,3.5,6.166,3.578,9.608.056,2.452-1.3,4.672-2.117,6.981a16.109,16.109,0,0,0-.727,7.54,117.962,117.962,0,0,0,14.48,10.5,4.219,4.219,0,0,0,.6-1.342,2.654,2.654,0,0,0-1.238-2.747,6.566,6.566,0,0,0,2.292-1.47,2.249,2.249,0,0,0,.416-2.54c1.406.176,3.075.264,4-.815a3.574,3.574,0,0,0,.4-3.251,13.4,13.4,0,0,1-.8-3.307,59.494,59.494,0,0,0,9.76-.328,6.336,6.336,0,0,0-2.971-3.722c1.47-.248,2.8-2,3.267-3.418a8.707,8.707,0,0,0,.064-4.417,2.351,2.351,0,0,1-.048-1.15,2.263,2.263,0,0,1,1.166-1.126q3.642-2.1,7.284-4.185a4.4,4.4,0,0,0,1.166-.855,3.477,3.477,0,0,0,.256-3.362,16.942,16.942,0,0,1-1.166-3.323c-.447-3.49,3.291-6,4.552-9.289a13.946,13.946,0,0,0,.687-4.065c.1-1.486.112-3.2-1.022-4.153-1.094-.919-2.8-.711-3.938-1.565-1.046-.783-1.406-2.292-2.548-2.923-1.038-.575-2.332-.208-3.49-.479-2.029-.471-3.307-2.811-5.383-3.027-1.166-.128-2.492.447-3.45-.232-.847-.607-.879-1.813-1.038-2.835a7.92,7.92,0,0,0-6.39-6.405c-1.206-.192-2.516-.12-3.546-.783s-1.51-1.925-2.332-2.859c-1.31-1.494-3.386-2.029-5.327-2.484q-3.954-.922-7.9-1.853c-1.4-.335-3.2-.511-3.961.719a5.4,5.4,0,0,0-.463,1.478,4.582,4.582,0,0,1-4.3,3.227,5.077,5.077,0,0,0-2.987-2.316,18.848,18.848,0,0,1-2.428-.575,3.4,3.4,0,0,1-1.469-4.72,4.238,4.238,0,0,0-.727-5.088,6.875,6.875,0,0,0-5.088-1.382c-.471-1.03.319-2.188,1.166-2.939s1.885-1.478,2.069-2.6c.3-1.757-1.949-3.091-3.65-2.572s-2.787,2.18-3.506,3.81a11.483,11.483,0,0,1-1.414,2.708,2.775,2.775,0,0,1-2.684,1.1C8.442,81.978,7.907,80.308,7.6,78.9a22.4,22.4,0,0,1-.751-5.759A7.517,7.517,0,0,1,9.017,67.9c2.324-2.14,5.9-1.933,9.041-1.589a2.3,2.3,0,0,1,.24-3.035,3.451,3.451,0,0,1,3.131-.767,4.3,4.3,0,0,1,2.42,1.446c.895,1.086,1.15,2.564,1.821,3.794s2.2,2.292,3.434,1.629c1.078-.575,1.246-2.061.982-3.251a12.073,12.073,0,0,1-.743-3.554c.184-2.308,2.588-3.706,4.7-4.656s4.537-2.236,4.872-4.536a4.24,4.24,0,0,1,.255-1.31,2.56,2.56,0,0,1,.95-.894c6.174-4.081,12.46-8.219,19.52-10.447.367-.12.407.008.783-.08.527-.3.176-1.142-.328-1.478s-1.174-.6-1.3-1.19c-.088-.431.168-.863.232-1.3A1.625,1.625,0,0,0,56.9,35.038c-.567-.751.551-1.621,1.462-1.877A39.923,39.923,0,0,1,66.707,31.8a1.486,1.486,0,0,1,.951.16,1.13,1.13,0,0,1,.072,1.55,8.753,8.753,0,0,1-1.27,1.158,3.489,3.489,0,0,0-.911,3.506c1.478.751,3.075,1.526,4.712,1.262s3.075-2.1,2.308-3.562c-.711-1.366-2.859-1.677-3.227-3.171-.431-1.749,2.045-3.307,1.486-5.016-.24-.751-.99-1.2-1.565-1.733a4.726,4.726,0,0,1-1.03-5.223A5.951,5.951,0,0,1,63.025,19.1c-1.246-1.254-2.236-3.243-4.01-3.179-1.621.048-3.019,1.941-4.536,1.366-.375-.144-.767-.431-1.126-.264a.931.931,0,0,0-.423.695c-.383,1.845.28,3.945-.727,5.543C51.108,25,48.577,25.239,47.251,26.8c-.719.847-1,1.989-1.661,2.883s-2.061,1.47-2.859.687a3.936,3.936,0,0,0-1.07-4.792,10.293,10.293,0,0,0-2.364-1.15,14.028,14.028,0,0,1-2.644-1.47,2.619,2.619,0,0,1-.966-1.038,2.388,2.388,0,0,1,.064-1.645,6.725,6.725,0,0,1,5.343-4.425c1.054-.144,2.284-.1,2.987-.9.367-.423.559-1.07,1.1-1.238a1.607,1.607,0,0,1,1.014.12l3.946,1.39a2.7,2.7,0,0,0,1.406.232.945.945,0,0,0,.823-1c-.128-.655-1.134-.966-1.038-1.629a1.037,1.037,0,0,1,.328-.559,14.113,14.113,0,0,1,11.19-4.417c.5.823-.288,1.789-.951,2.484s-1.182,1.949-.383,2.484a2.1,2.1,0,0,0,1.046.24,9.124,9.124,0,0,1,2.8.847c1.366.591,2.708,1.246,4.017,1.949a5.069,5.069,0,0,1,.1-2.588,1.757,1.757,0,0,1,2.077-1.126c.783.3,1.182,1.342,2.021,1.438,1.11.128,1.55-1.517,1.086-2.54s-1.39-1.869-1.462-2.995c-.056-.751.232-1.685-.367-2.141a1.589,1.589,0,0,0-.711-.256Q64.59,4.269,57.058,2.883c-.895-.168-2.18-.04-2.22.863-.024.511.431,1.014.232,1.478-.216.5-.919.455-1.43.631a1.941,1.941,0,0,0-1.118,2.053,5.6,5.6,0,0,0,.943,2.308c-.982-.407-2.46-.479-3.442-.895a13.251,13.251,0,0,0-.863-3.315,1.17,1.17,0,0,0-1.526-.942c-1.294.2-2.588.391-3.882.591A1.5,1.5,0,0,0,42.866,6c-.5.535-.008,1.39-.024,2.125A1.991,1.991,0,0,1,41.3,9.84a5.809,5.809,0,0,1-2.46-.032l-5.431-.839a8.9,8.9,0,0,0,4.105-2.748c.719-.847,1.1-2.428.064-2.827a2.48,2.48,0,0,0-.943-.072c-2.46.016-4.4-2.037-6.7-2.907A6.587,6.587,0,0,0,27.675,0Z"
            transform="matrix(0.809, -0.588, 0.588, 0.809, 24.504, 171.746)"
          />
          <path
            id="accent-6"
            data-name="accent"
            class="cls-4"
            d="M152.414,97.965a2.884,2.884,0,0,1-2.444,1.158c-2.5-.216-3.554-3.818-6.03-4.225a.966.966,0,0,0-.655.064c-.367.2-.431.695-.455,1.11a13.771,13.771,0,0,0,.615,6.1c1.174,2.779,4.217,5.112,3.578,8.059-3.434-1.589-5.223-5.447-6.03-9.145s-.943-7.58-2.4-11.078c-1.11,1.414-3.426.248-4.433-1.238-.958-1.406-1.55-3.035-2.476-4.465a5.494,5.494,0,0,0-4.041-2.779c-1.781-.08-3.331,1.142-4.688,2.3a10.851,10.851,0,0,0-2.915,3.243c-.95,1.917-.7,4.169-.751,6.3a9.619,9.619,0,0,1-2.109,6.429c-1.573,1.685-4.473,2.276-6.206.751a7,7,0,0,1-1.733-3.123,151.967,151.967,0,0,1-4.7-16.756c-.288,1.294-1.43,2.963-2.516,2.2a2.244,2.244,0,0,1-.575-.751C99.429,78.7,95.683,76.64,91.89,75.4s-7.771-1.8-11.517-3.163A29.447,29.447,0,0,1,74.39,69.26a4.711,4.711,0,0,0-.287,4.808,3.852,3.852,0,0,0,4.329,1.813c.831-.271,1.533-.847,2.356-1.134a1.843,1.843,0,0,1,2.292.655c.351.759-.176,1.677.088,2.476.391,1.206,2.221,1.3,2.859,2.4a2.225,2.225,0,0,1-.6,2.572,10.772,10.772,0,0,1-2.412,1.486c-2.684,1.494-4.593,4.041-6.941,6.022s-5.663,3.434-8.458,2.164c.663-3.378-3.354-5.854-4.1-9.217-.248-1.11-.12-2.284-.463-3.363-.5-1.565-1.893-2.636-3.027-3.818a15.006,15.006,0,0,1-4.113-10.9,15.14,15.14,0,0,0,0-4.161,3.12,3.12,0,0,0-2.828-2.6c-3.171.144-7.172.383-8.833-2.324-.6-.966-.854-2.38.008-3.123a3.016,3.016,0,0,1,2.292-.391c2.388.232,4.768.471,7.156.7,1.669.16,3.474.3,4.912-.575s2.06-3.195.727-4.225c-.966-.751-2.708-.711-3-1.9-.232-1,.871-2.125.271-2.963-.423-.591-1.382-.431-1.965.016a12.846,12.846,0,0,1-1.653,1.446c-1.142.591-2.5.024-3.73-.359s-2.875-.415-3.466.727c-.671,1.27.583,2.947-.072,4.225-.879,1.685-3.834.727-5.064,2.18-1.406,1.661.958,4.153.487,6.278a3.913,3.913,0,0,1-3.858-.216,3.735,3.735,0,0,1-1.613-3.482c.112-.958.615-1.941.28-2.843a3.319,3.319,0,0,0-1.685-1.541q-3.474-1.929-6.949-3.842c-.647,1.2.168,2.676,1.19,3.578s2.292,1.573,2.963,2.755a3.622,3.622,0,0,1-1.358,4.776.843.843,0,0,1-.695.12.963.963,0,0,1-.447-.6c-1.222-3.139-3.067-6.23-6.006-7.867s-7.172-1.3-9.105,1.454c-.455.655-.767,1.406-1.166,2.1C10.6,56.25,6.047,57.991,1.8,57.879a2.1,2.1,0,0,1-1.19-.28c-.687-.471-.655-1.478-.551-2.308.152-1.174.3-2.34.447-3.514a2.815,2.815,0,0,1,.775-1.925c.791-.623,1.925-.232,2.931-.248a3.692,3.692,0,0,0,3.362-2.6,4.173,4.173,0,0,0-1.166-4.153c-.455-.431-1.07-.974-.831-1.557a1.294,1.294,0,0,1,.9-.607c1.8-.519,3.706-.655,5.471-1.278s3.49-1.877,3.914-3.706c.128-.559.184-1.238.687-1.518a2.225,2.225,0,0,1,.8-.16,3.887,3.887,0,0,0,3.331-4.049c.847-.591,2.037-.152,2.859.479a7.942,7.942,0,0,0,2.54,1.733c1.861.511,3.658-1.142,5.591-1.15a6.992,6.992,0,0,0,2.412.008c.775-.28,1.238-1.046,1.829-1.613s1.637-.918,2.188-.3c-.16-1.158-.312-2.308-.471-3.458a6.8,6.8,0,0,0,5.535-1.006l-6.03-2.037a1.3,1.3,0,0,1-.567-.3c-.439-.471,0-1.206.351-1.741.854-1.286,1-3.4-.407-4.041-.958-.439-2.053.088-2.971.6-1.47.815-2.939,1.637-4.409,2.452-.136.839.886,1.318,1.518,1.877a2.545,2.545,0,0,1-1.661,4.449,3.188,3.188,0,0,1,.567,2.692l-2.963.216a1.273,1.273,0,0,1-.958-.192c-.319-.28-.272-.775-.351-1.19a2.571,2.571,0,0,0-2.172-1.893,7.5,7.5,0,0,0-3.027.28,1.844,1.844,0,0,1-1.31-.032,1.307,1.307,0,0,1-.511-.655,3.339,3.339,0,0,1,.671-3.211,18.366,18.366,0,0,1,2.524-2.324,14.715,14.715,0,0,0,4.385-6.789c1.629-.687,3.314-1.613,4.952-2.3A19.783,19.783,0,0,1,34.9,9.143a19.436,19.436,0,0,1,4.033-.192c1.837.032,3.682.064,5.519.1a13.285,13.285,0,0,1,4.832.695,4.508,4.508,0,0,1,2.947,3.6,1.106,1.106,0,0,1-.359,1.014,1.294,1.294,0,0,1-.695.16c-1.526.048-2.172.431-3.7.487a6.24,6.24,0,0,0,3.458,2.3c2.476.319,4.257-2.244,5.4-4.473a2.179,2.179,0,0,0,2.276,2.021,4.59,4.59,0,0,0,1.717-.671,33.781,33.781,0,0,1,16.014-4.137,1.724,1.724,0,0,1,1.318-1.9c1.142-.224,2.164.759,2.716,1.781A9.578,9.578,0,0,0,82.146,12.9c.87.767,2.556.727,2.9-.375.336-1.062-.775-1.973-1.693-2.6s-1.893-1.781-1.27-2.708A82.113,82.113,0,0,1,96.331,4.926a6.063,6.063,0,0,0,2.4-.415,1.862,1.862,0,0,0,1.118-1.973A5.446,5.446,0,0,1,94.174.4c4.944-.407,10.12-.767,14.872.344l4.161,3.53c-.791.823-1.845,1.6-1.27,2.42a1.771,1.771,0,0,0,1.462.5c1.006.016,2.013.04,3.011.04a117.091,117.091,0,0,1,35.749,74.885c-1.677-.064-3.219,2.061-3,3.914.256,2.149,1.805,3.874,2.915,5.727a8.683,8.683,0,0,1,.5.935Z"
            transform="matrix(0.809, -0.588, 0.588, 0.809, 81.482, 110.241)"
          />
        </g>
        <path
          id="Tracé_2560"
          data-name="Tracé 2560"
          class="cls-4"
          d="M73.453,35.374H69.621a2.941,2.941,0,0,1-2.788-2.289h0L60.849,12.767A4.389,4.389,0,0,0,57.177,9.55h0C52.754,8.879,47,7.1,44.913,7.1c-2.577,0-4.162.984-7.928.984S31.237,2.179,29.85.458,21.724,2.425,17.76,2.425,9.436,5.621,9.436,9.8,5.67,16.686,1.508,21.85,2.8,39.431,5.868,43.242,13,47.914,17.76,45.455,24.2,44.1,26.48,46.93s2.378,6.885,5.153,10.327,1.387,16.229,1.387,21.884,3.766,12.786,6.739,16.474,3.369,2.459,7.928,0,8.126-14.262,12.288-19.425S63.345,63.4,63.345,58.979s7.73-13.032,11.694-17.95S73.453,35.374,73.453,35.374Z"
          transform="translate(110.021 167.162) rotate(-37)"
        />
        <path
          id="Tracé_2563"
          data-name="Tracé 2563"
          class="cls-4"
          d="M7.065.256c1.229.571,1.583,1.916.75,3.833s2.208,5.457-.75,8.415-3.749,1.75-5.5,0-1.958-2.958-1-3.916S1.441,4.214,2.65,3.006,4.732-.827,7.065.256Z"
          transform="translate(186.143 175.187) rotate(-30)"
        />
        <path
          id="Tracé_2564"
          data-name="Tracé 2564"
          class="cls-4"
          d="M4.905,12.5c-1.75-1.75-1.958-2.958-1-3.916S4.78,4.214,5.989,3.006c.6-.6,1.123-1.559,1.783-2.23A2.111,2.111,0,0,0,7.065.256C4.732-.827,3.858,1.8,2.65,3.006S1.525,7.63.567,8.588s-.75,2.166,1,3.916c1.5,1.5,2.3,2.6,4.363,1.015C5.612,13.229,5.281,12.879,4.905,12.5Z"
          transform="translate(186.143 175.187) rotate(-30)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SvgHomeProgramWebPicto extends Vue {}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/general';

.cls-1,
.cls-4 {
  fill: var(--v-stickers_primaire-base);
}

.cls-1,
.cls-10,
.cls-13 {
  opacity: 0.1;
}

.cls-2,
.cls-24 {
  fill: var(--v-stickers_secondaire-base);
}

.cls-3 {
  fill: #cacaca;
}

.cls-5 {
  fill: #3d3f42;
}

.cls-6 {
  fill: #f3f3f3;
}

.cls-7 {
  fill: #6f6f6f;
}

.cls-8 {
  fill: #454545;
}

.cls-9 {
  fill: #ababab;
}

.cls-10,
.cls-16,
.cls-22 {
  fill: #fff;
}

.cls-11 {
  fill: #33323d;
}

.cls-12 {
  fill: #4c4981;
}

.cls-14 {
  fill: #fbbebe;
}

.cls-15 {
  fill: #504f60;
}

.cls-16,
.cls-18 {
  opacity: 0.2;
}

.cls-17 {
  fill: #2f2e41;
}

.cls-19 {
  fill: #ffb8b8;
}

.cls-20 {
  fill: var(--v-stickers_secondaire-base);
}

.cls-21 {
  fill: #ccc;
}

.cls-23 {
  fill: #f2f2f2;
}

.cls-24 {
  font-size: 50px;
  font-family: DreamOrphans-Regular, Dream Orphans;
  letter-spacing: -0.02em;
}
</style>
